export interface ICountryCodes {
  fips: string,
  phoneCode: number,
  langId: 1033 | 1037,
  country: string
}

export const countryCode: Readonly<ICountryCodes[]> = [
  {
    fips: "AW",
    phoneCode: 297,
    langId: 1033,
    country: "Aruba"
  },
  {
    fips: "AW",
    phoneCode: 297,
    langId: 1037,
    country: "ארובה"
  },
  {
    fips: "AG",
    phoneCode: 268,
    langId: 1033,
    country: "Antigua and Barbuda"
  },
  {
    fips: "AG",
    phoneCode: 268,
    langId: 1037,
    country: "אנטיגואה וברבואה"
  },
  {
    fips: "AE",
    phoneCode: 971,
    langId: 1033,
    country: "United Arab Emirates"
  },
  {
    fips: "AE",
    phoneCode: 971,
    langId: 1037,
    country: "איחוד האמירויות הערביות"
  },
  {
    fips: "AF",
    phoneCode: 93,
    langId: 1033,
    country: "Afghanistan"
  },
  {
    fips: "AF",
    phoneCode: 93,
    langId: 1037,
    country: "אפגניסטן"
  },
  {
    fips: "AG",
    phoneCode: 213,
    langId: 1033,
    country: "Algeria"
  },
  {
    fips: "AG",
    phoneCode: 213,
    langId: 1037,
    country: "אלג'יריה"
  },
  {
    fips: "AZ",
    phoneCode: 994,
    langId: 1033,
    country: "Azerbaijan"
  },
  {
    fips: "AZ",
    phoneCode: 994,
    langId: 1037,
    country: "אזרביגאן"
  },
  {
    fips: "AL",
    phoneCode: 355,
    langId: 1033,
    country: "Albania"
  },
  {
    fips: "AL",
    phoneCode: 355,
    langId: 1037,
    country: "אלבניה"
  },
  {
    fips: "AM",
    phoneCode: 374,
    langId: 1033,
    country: "Armenia"
  },
  {
    fips: "AM",
    phoneCode: 374,
    langId: 1037,
    country: "ארמניה"
  },
  {
    fips: "AN",
    phoneCode: 376,
    langId: 1033,
    country: "Andorra"
  },
  {
    fips: "AN",
    phoneCode: 376,
    langId: 1037,
    country: "אנדורה"
  },
  {
    fips: "AO",
    phoneCode: 244,
    langId: 1033,
    country: "Angola"
  },
  {
    fips: "AO",
    phoneCode: 244,
    langId: 1037,
    country: "אנגולה"
  },
  {
    fips: "AQ",
    phoneCode: 684,
    langId: 1033,
    country: "American Samoa"
  },
  {
    fips: "AQ",
    phoneCode: 684,
    langId: 1037,
    country: "סמואה האמריקאית"
  },
  {
    fips: "AR",
    phoneCode: 54,
    langId: 1033,
    country: "Argentina"
  },
  {
    fips: "AR",
    phoneCode: 54,
    langId: 1037,
    country: "ארגנטינה"
  },
  {
    fips: "AS",
    phoneCode: 61,
    langId: 1033,
    country: "Australia"
  },
  {
    fips: "AS",
    phoneCode: 61,
    langId: 1037,
    country: "אוסטרליה"
  },
  {
    fips: "AU",
    phoneCode: 43,
    langId: 1033,
    country: "Austria"
  },
  {
    fips: "AU",
    phoneCode: 43,
    langId: 1037,
    country: "אוסטריה"
  },
  {
    fips: "AI",
    phoneCode: 809,
    langId: 1033,
    country: "Anguilla"
  },
  {
    fips: "AI",
    phoneCode: 809,
    langId: 1037,
    country: "אנגואילה"
  },
  {
    fips: "AX",
    phoneCode: 500,
    langId: 1033,
    country: "ֵland Islands"
  },
  {
    fips: "AX",
    phoneCode: 500,
    langId: 1037,
    country: "איי פוקלנד"
  },
  {
    fips: "BA",
    phoneCode: 973,
    langId: 1033,
    country: "Bahrain"
  },
  {
    fips: "BA",
    phoneCode: 973,
    langId: 1037,
    country: "בחריין"
  },
  {
    fips: "BB",
    phoneCode: 246,
    langId: 1033,
    country: "Barbados"
  },
  {
    fips: "BB",
    phoneCode: 246,
    langId: 1037,
    country: "ברבדוס"
  },
  {
    fips: "BW",
    phoneCode: 267,
    langId: 1033,
    country: "Botswana"
  },
  {
    fips: "BW",
    phoneCode: 267,
    langId: 1037,
    country: "בצואנה"
  },
  {
    fips: "BD",
    phoneCode: 809,
    langId: 1033,
    country: "Bermuda"
  },
  {
    fips: "BD",
    phoneCode: 809,
    langId: 1037,
    country: "ברמודה"
  },
  {
    fips: "BE",
    phoneCode: 32,
    langId: 1033,
    country: "Belgium"
  },
  {
    fips: "BE",
    phoneCode: 32,
    langId: 1037,
    country: "בלגיה"
  },
  {
    fips: "BF",
    phoneCode: 242,
    langId: 1033,
    country: "Bahamas, The"
  },
  {
    fips: "BF",
    phoneCode: 242,
    langId: 1037,
    country: "בהאמס"
  },
  {
    fips: "BG",
    phoneCode: 880,
    langId: 1033,
    country: "Bangladesh"
  },
  {
    fips: "BG",
    phoneCode: 880,
    langId: 1037,
    country: "באנגלדש"
  },
  {
    fips: "BH",
    phoneCode: 501,
    langId: 1033,
    country: "Belize"
  },
  {
    fips: "BH",
    phoneCode: 501,
    langId: 1037,
    country: "בליז"
  },
  {
    fips: "BA",
    phoneCode: 387,
    langId: 1033,
    country: "Bosnia and Herzegovina"
  },
  {
    fips: "BA",
    phoneCode: 387,
    langId: 1037,
    country: "בוסניה והרצגובינה"
  },
  {
    fips: "BL",
    phoneCode: 591,
    langId: 1033,
    country: "Bolivia"
  },
  {
    fips: "BL",
    phoneCode: 591,
    langId: 1037,
    country: "בוליביה"
  },
  {
    fips: "BM",
    phoneCode: 95,
    langId: 1033,
    country: "Burma"
  },
  {
    fips: "BM",
    phoneCode: 95,
    langId: 1037,
    country: "בורמה"
  },
  {
    fips: "BN",
    phoneCode: 229,
    langId: 1033,
    country: "Benin"
  },
  {
    fips: "BN",
    phoneCode: 229,
    langId: 1037,
    country: "בנין"
  },
  {
    fips: "BO",
    phoneCode: 375,
    langId: 1033,
    country: "Belarus"
  },
  {
    fips: "BO",
    phoneCode: 375,
    langId: 1037,
    country: "בלארוס"
  },
  {
    fips: "SB",
    phoneCode: 677,
    langId: 1033,
    country: "Solomon Islands"
  },
  {
    fips: "SB",
    phoneCode: 677,
    langId: 1037,
    country: "איי סולומון"
  },
  {
    fips: "BR",
    phoneCode: 55,
    langId: 1033,
    country: "Brazil"
  },
  {
    fips: "BR",
    phoneCode: 55,
    langId: 1037,
    country: "ברזיל"
  },
  {
    fips: "BT",
    phoneCode: 975,
    langId: 1033,
    country: "Bhutan"
  },
  {
    fips: "BT",
    phoneCode: 975,
    langId: 1037,
    country: "בוטן"
  },
  {
    fips: "BG",
    phoneCode: 359,
    langId: 1033,
    country: "Bulgaria"
  },
  {
    fips: "BG",
    phoneCode: 359,
    langId: 1037,
    country: "בולגריה"
  },
  {
    fips: "BN",
    phoneCode: 673,
    langId: 1033,
    country: "Brunei"
  },
  {
    fips: "BN",
    phoneCode: 673,
    langId: 1037,
    country: "ברוני דר-אסלם"
  },
  {
    fips: "BY",
    phoneCode: 257,
    langId: 1033,
    country: "Burundi"
  },
  {
    fips: "BY",
    phoneCode: 257,
    langId: 1037,
    country: "בורונדי"
  },
  {
    fips: "CA",
    phoneCode: 1,
    langId: 1033,
    country: "Canada"
  },
  {
    fips: "CA",
    phoneCode: 1,
    langId: 1037,
    country: "קנדה"
  },
  {
    fips: "KH",
    phoneCode: 855,
    langId: 1033,
    country: "Cambodia"
  },
  {
    fips: "KH",
    phoneCode: 855,
    langId: 1037,
    country: "קמבודיה"
  },
  {
    fips: "CD",
    phoneCode: 235,
    langId: 1033,
    country: "Chad"
  },
  {
    fips: "CD",
    phoneCode: 235,
    langId: 1037,
    country: "צ'אד"
  },
  {
    fips: "LK",
    phoneCode: 94,
    langId: 1033,
    country: "Sri Lanka"
  },
  {
    fips: "LK",
    phoneCode: 94,
    langId: 1037,
    country: "סרי לנקה"
  },
  {
    fips: "CG",
    phoneCode: 242,
    langId: 1033,
    country: "Congo, Democratic Republic of the"
  },
  {
    fips: "CG",
    phoneCode: 242,
    langId: 1037,
    country: "קונגו הדמוקראטית"
  },
  {
    fips: "CH",
    phoneCode: 86,
    langId: 1033,
    country: "China"
  },
  {
    fips: "CH",
    phoneCode: 86,
    langId: 1037,
    country: "סין"
  },
  {
    fips: "CI",
    phoneCode: 56,
    langId: 1033,
    country: "Chile"
  },
  {
    fips: "CI",
    phoneCode: 56,
    langId: 1037,
    country: "צ'ילה"
  },
  {
    fips: "KY",
    phoneCode: 345,
    langId: 1033,
    country: "Cayman Islands"
  },
  {
    fips: "KY",
    phoneCode: 345,
    langId: 1037,
    country: "איי קיימן"
  },
  {
    fips: "CM",
    phoneCode: 237,
    langId: 1033,
    country: "Cameroon"
  },
  {
    fips: "CM",
    phoneCode: 237,
    langId: 1037,
    country: "קאמרון"
  },
  {
    fips: "CN",
    phoneCode: 269,
    langId: 1033,
    country: "Comoros"
  },
  {
    fips: "CN",
    phoneCode: 269,
    langId: 1037,
    country: "קומורוס"
  },
  {
    fips: "CO",
    phoneCode: 57,
    langId: 1033,
    country: "Colombia"
  },
  {
    fips: "CO",
    phoneCode: 57,
    langId: 1037,
    country: "קולומביה"
  },
  {
    fips: "CR",
    phoneCode: 506,
    langId: 1033,
    country: "Costa Rica"
  },
  {
    fips: "CR",
    phoneCode: 506,
    langId: 1037,
    country: "קוסטה ריקה"
  },
  {
    fips: "CF",
    phoneCode: 236,
    langId: 1033,
    country: "Central African Republic"
  },
  {
    fips: "CF",
    phoneCode: 236,
    langId: 1037,
    country: "רפובליקה מרכז אפריקאית"
  },
  {
    fips: "CU",
    phoneCode: 53,
    langId: 1033,
    country: "Cuba"
  },
  {
    fips: "CU",
    phoneCode: 53,
    langId: 1037,
    country: "קובה"
  },
  {
    fips: "CV",
    phoneCode: 238,
    langId: 1033,
    country: "Cape Verde"
  },
  {
    fips: "CV",
    phoneCode: 238,
    langId: 1037,
    country: "כף ורדה"
  },
  {
    fips: "CW",
    phoneCode: 682,
    langId: 1033,
    country: "Cook Islands"
  },
  {
    fips: "CW",
    phoneCode: 682,
    langId: 1037,
    country: "איי קוק"
  },
  {
    fips: "CY",
    phoneCode: 357,
    langId: 1033,
    country: "Cyprus"
  },
  {
    fips: "CY",
    phoneCode: 357,
    langId: 1037,
    country: "קפריסין"
  },
  {
    fips: "DK",
    phoneCode: 45,
    langId: 1033,
    country: "Denmark"
  },
  {
    fips: "DK",
    phoneCode: 45,
    langId: 1037,
    country: "דנמרק"
  },
  {
    fips: "DJ",
    phoneCode: 253,
    langId: 1033,
    country: "Djibouti"
  },
  {
    fips: "DJ",
    phoneCode: 253,
    langId: 1037,
    country: "ג'יבטוי"
  },
  {
    fips: "DM",
    phoneCode: 809,
    langId: 1033,
    country: "Dominica"
  },
  {
    fips: "DM",
    phoneCode: 809,
    langId: 1037,
    country: "דומיניקה"
  },
  {
    fips: "EC",
    phoneCode: 593,
    langId: 1033,
    country: "Ecuador"
  },
  {
    fips: "EC",
    phoneCode: 593,
    langId: 1037,
    country: "אקוודור"
  },
  {
    fips: "EG",
    phoneCode: 20,
    langId: 1033,
    country: "Egypt"
  },
  {
    fips: "EG",
    phoneCode: 20,
    langId: 1037,
    country: "מצרים"
  },
  {
    fips: "IE",
    phoneCode: 353,
    langId: 1033,
    country: "Ireland"
  },
  {
    fips: "IE",
    phoneCode: 353,
    langId: 1037,
    country: "אירלנד"
  },
  {
    fips: "GQ",
    phoneCode: 240,
    langId: 1033,
    country: "Equatorial Guinea"
  },
  {
    fips: "GQ",
    phoneCode: 240,
    langId: 1037,
    country: "גינאה המשוונית"
  },
  {
    fips: "EE",
    phoneCode: 372,
    langId: 1033,
    country: "Estonia"
  },
  {
    fips: "EE",
    phoneCode: 372,
    langId: 1037,
    country: "אסטוניה"
  },
  {
    fips: "ER",
    phoneCode: 291,
    langId: 1033,
    country: "Eritrea"
  },
  {
    fips: "ER",
    phoneCode: 291,
    langId: 1037,
    country: "אריתריאה"
  },
  {
    fips: "ES",
    phoneCode: 503,
    langId: 1033,
    country: "El Salvador"
  },
  {
    fips: "ES",
    phoneCode: 503,
    langId: 1037,
    country: "סלבדור"
  },
  {
    fips: "ET",
    phoneCode: 251,
    langId: 1033,
    country: "Ethiopia"
  },
  {
    fips: "ET",
    phoneCode: 251,
    langId: 1037,
    country: "אתיופיה"
  },
  {
    fips: "CZ",
    phoneCode: 420,
    langId: 1033,
    country: "Czech Republic"
  },
  {
    fips: "CZ",
    phoneCode: 420,
    langId: 1037,
    country: "צ'כיה"
  },
  {
    fips: "GF",
    phoneCode: 594,
    langId: 1033,
    country: "French Guiana"
  },
  {
    fips: "GF",
    phoneCode: 594,
    langId: 1037,
    country: "גיניאה הצרפתית"
  },
  {
    fips: "FI",
    phoneCode: 358,
    langId: 1033,
    country: "Finland"
  },
  {
    fips: "FI",
    phoneCode: 358,
    langId: 1037,
    country: "פינלנד"
  },
  {
    fips: "FJ",
    phoneCode: 679,
    langId: 1033,
    country: "Fiji"
  },
  {
    fips: "FJ",
    phoneCode: 679,
    langId: 1037,
    country: "איי פיגי"
  },
  {
    fips: "FM",
    phoneCode: 691,
    langId: 1033,
    country: "Micronesia, Federated States of"
  },
  {
    fips: "FM",
    phoneCode: 691,
    langId: 1037,
    country: "מיקרונזיה"
  },
  {
    fips: "FO",
    phoneCode: 298,
    langId: 1033,
    country: "Faroe Islands"
  },
  {
    fips: "FO",
    phoneCode: 298,
    langId: 1037,
    country: "איי פארו"
  },
  {
    fips: "PF",
    phoneCode: 689,
    langId: 1033,
    country: "French Polynesia"
  },
  {
    fips: "PF",
    phoneCode: 689,
    langId: 1037,
    country: "פולינזיה הצרפתית"
  },
  {
    fips: "FR",
    phoneCode: 33,
    langId: 1033,
    country: "France"
  },
  {
    fips: "FR",
    phoneCode: 33,
    langId: 1037,
    country: "צרפת"
  },
  {
    fips: "GA",
    phoneCode: 220,
    langId: 1033,
    country: "Gambia, The"
  },
  {
    fips: "GA",
    phoneCode: 220,
    langId: 1037,
    country: "גמביה"
  },
  {
    fips: "GB",
    phoneCode: 241,
    langId: 1033,
    country: "Gabon"
  },
  {
    fips: "GB",
    phoneCode: 241,
    langId: 1037,
    country: "גבון"
  },
  {
    fips: "GG",
    phoneCode: 995,
    langId: 1033,
    country: "Georgia"
  },
  {
    fips: "GG",
    phoneCode: 995,
    langId: 1037,
    country: "גיאורגיה"
  },
  {
    fips: "GH",
    phoneCode: 233,
    langId: 1033,
    country: "Ghana"
  },
  {
    fips: "GH",
    phoneCode: 233,
    langId: 1037,
    country: "גאנה"
  },
  {
    fips: "GI",
    phoneCode: 350,
    langId: 1033,
    country: "Gibraltar"
  },
  {
    fips: "GI",
    phoneCode: 350,
    langId: 1037,
    country: "גיברלטר"
  },
  {
    fips: "GD",
    phoneCode: 473,
    langId: 1033,
    country: "Grenada"
  },
  {
    fips: "GD",
    phoneCode: 473,
    langId: 1037,
    country: "גרנדה"
  },
  {
    fips: "GL",
    phoneCode: 299,
    langId: 1033,
    country: "Greenland"
  },
  {
    fips: "GL",
    phoneCode: 299,
    langId: 1037,
    country: "גרינלנד"
  },
  {
    fips: "GM",
    phoneCode: 49,
    langId: 1033,
    country: "Deutschland"
  },
  {
    fips: "GM",
    phoneCode: 49,
    langId: 1037,
    country: "גרמניה"
  },
  {
    fips: "GQ",
    phoneCode: 671,
    langId: 1033,
    country: "Guam"
  },
  {
    fips: "GQ",
    phoneCode: 671,
    langId: 1037,
    country: "גואם"
  },
  {
    fips: "GR",
    phoneCode: 30,
    langId: 1033,
    country: "Greece"
  },
  {
    fips: "GR",
    phoneCode: 30,
    langId: 1037,
    country: "יוון"
  },
  {
    fips: "GT",
    phoneCode: 502,
    langId: 1033,
    country: "Guatemala"
  },
  {
    fips: "GT",
    phoneCode: 502,
    langId: 1037,
    country: "גווטמלה"
  },
  {
    fips: "GN",
    phoneCode: 224,
    langId: 1033,
    country: "Guinea"
  },
  {
    fips: "GN",
    phoneCode: 224,
    langId: 1037,
    country: "גינאה"
  },
  {
    fips: "GY",
    phoneCode: 592,
    langId: 1033,
    country: "Guyana"
  },
  {
    fips: "GY",
    phoneCode: 592,
    langId: 1037,
    country: "גויאנה"
  },
  {
    fips: "HT",
    phoneCode: 509,
    langId: 1033,
    country: "Haiti"
  },
  {
    fips: "HT",
    phoneCode: 509,
    langId: 1037,
    country: "האיטי"
  },
  {
    fips: "HK",
    phoneCode: 852,
    langId: 1033,
    country: "Hong Kong"
  },
  {
    fips: "HK",
    phoneCode: 852,
    langId: 1037,
    country: "הונג קונג"
  },
  {
    fips: "HN",
    phoneCode: 504,
    langId: 1033,
    country: "Honduras"
  },
  {
    fips: "HN",
    phoneCode: 504,
    langId: 1037,
    country: "הונדורס"
  },
  {
    fips: "HR",
    phoneCode: 385,
    langId: 1033,
    country: "Croatia"
  },
  {
    fips: "HR",
    phoneCode: 385,
    langId: 1037,
    country: "קוראטיה"
  },
  {
    fips: "HU",
    phoneCode: 36,
    langId: 1033,
    country: "Hungary"
  },
  {
    fips: "HU",
    phoneCode: 36,
    langId: 1037,
    country: "הונגריה"
  },
  {
    fips: "IS",
    phoneCode: 354,
    langId: 1033,
    country: "Iceland"
  },
  {
    fips: "IS",
    phoneCode: 354,
    langId: 1037,
    country: "איסלנד"
  },
  {
    fips: "ID",
    phoneCode: 62,
    langId: 1033,
    country: "Indonesia"
  },
  {
    fips: "ID",
    phoneCode: 62,
    langId: 1037,
    country: "אינדונזיה"
  },
  {
    fips: "IN",
    phoneCode: 91,
    langId: 1033,
    country: "India"
  },
  {
    fips: "IN",
    phoneCode: 91,
    langId: 1037,
    country: "הודו"
  },
  {
    fips: "IR",
    phoneCode: 98,
    langId: 1033,
    country: "Iran"
  },
  {
    fips: "IR",
    phoneCode: 98,
    langId: 1037,
    country: "אירן(פרס)"
  },
  {
    fips: "IL",
    phoneCode: 972,
    langId: 1033,
    country: "Israel"
  },
  {
    fips: "IL",
    phoneCode: 972,
    langId: 1037,
    country: "ישראל"
  },
  {
    fips: "IT",
    phoneCode: 39,
    langId: 1033,
    country: "Italy"
  },
  {
    fips: "IT",
    phoneCode: 39,
    langId: 1037,
    country: "איטליה"
  },
  {
    fips: "CI",
    phoneCode: 225,
    langId: 1033,
    country: "Cote d'Ivoire"
  },
  {
    fips: "CI",
    phoneCode: 225,
    langId: 1037,
    country: "חוף השנהב"
  },
  {
    fips: "IQ",
    phoneCode: 964,
    langId: 1033,
    country: "Iraq"
  },
  {
    fips: "IQ",
    phoneCode: 964,
    langId: 1037,
    country: "עיראק"
  },
  {
    fips: "JP",
    phoneCode: 81,
    langId: 1033,
    country: "Japan"
  },
  {
    fips: "JP",
    phoneCode: 81,
    langId: 1037,
    country: "יפן"
  },
  {
    fips: "JM",
    phoneCode: 876,
    langId: 1033,
    country: "Jamaica"
  },
  {
    fips: "JM",
    phoneCode: 876,
    langId: 1037,
    country: "ג'מיקה"
  },
  {
    fips: "JO",
    phoneCode: 962,
    langId: 1033,
    country: "Jordan"
  },
  {
    fips: "JO",
    phoneCode: 962,
    langId: 1037,
    country: "ירדן"
  },
  {
    fips: "KE",
    phoneCode: 254,
    langId: 1033,
    country: "Kenya"
  },
  {
    fips: "KE",
    phoneCode: 254,
    langId: 1037,
    country: "קניה"
  },
  {
    fips: "KN",
    phoneCode: 850,
    langId: 1033,
    country: "Korea, North"
  },
  {
    fips: "KN",
    phoneCode: 850,
    langId: 1037,
    country: "צפון קוריאה"
  },
  {
    fips: "KR",
    phoneCode: 686,
    langId: 1033,
    country: "Kiribati"
  },
  {
    fips: "KR",
    phoneCode: 686,
    langId: 1037,
    country: "קיריבטי"
  },
  {
    fips: "KR",
    phoneCode: 82,
    langId: 1033,
    country: "Korea, South"
  },
  {
    fips: "KR",
    phoneCode: 82,
    langId: 1037,
    country: "דרום קוריאה"
  },
  {
    fips: "KW",
    phoneCode: 965,
    langId: 1033,
    country: "Kuwait"
  },
  {
    fips: "KW",
    phoneCode: 965,
    langId: 1037,
    country: "כווית"
  },
  {
    fips: "KZ",
    phoneCode: 7,
    langId: 1033,
    country: "Kazakhstan"
  },
  {
    fips: "KZ",
    phoneCode: 7,
    langId: 1037,
    country: "קזחסטן"
  },
  {
    fips: "LA",
    phoneCode: 856,
    langId: 1033,
    country: "Laos"
  },
  {
    fips: "LA",
    phoneCode: 856,
    langId: 1037,
    country: "לאוס"
  },
  {
    fips: "LB",
    phoneCode: 961,
    langId: 1033,
    country: "Lebanon"
  },
  {
    fips: "LB",
    phoneCode: 961,
    langId: 1037,
    country: "לבנון"
  },
  {
    fips: "LV",
    phoneCode: 371,
    langId: 1033,
    country: "Latvia"
  },
  {
    fips: "LV",
    phoneCode: 371,
    langId: 1037,
    country: "לטביה"
  },
  {
    fips: "LT",
    phoneCode: 370,
    langId: 1033,
    country: "Lithuania"
  },
  {
    fips: "LT",
    phoneCode: 370,
    langId: 1037,
    country: "ליטא"
  },
  {
    fips: "LI",
    phoneCode: 231,
    langId: 1033,
    country: "Liberia"
  },
  {
    fips: "LI",
    phoneCode: 231,
    langId: 1037,
    country: "ליבריה"
  },
  {
    fips: "SK",
    phoneCode: 421,
    langId: 1033,
    country: "Slovakia"
  },
  {
    fips: "SK",
    phoneCode: 421,
    langId: 1037,
    country: "סלובקיה"
  },
  {
    fips: "LS",
    phoneCode: 423,
    langId: 1033,
    country: "Lichtenstein"
  },
  {
    fips: "LS",
    phoneCode: 423,
    langId: 1037,
    country: "ליכטנשטיין"
  },
  {
    fips: "LT",
    phoneCode: 266,
    langId: 1033,
    country: "Lesotho"
  },
  {
    fips: "LT",
    phoneCode: 266,
    langId: 1037,
    country: "לסוטו"
  },
  {
    fips: "LU",
    phoneCode: 352,
    langId: 1033,
    country: "Luxemburg"
  },
  {
    fips: "LU",
    phoneCode: 352,
    langId: 1037,
    country: "לוקסמבורג"
  },
  {
    fips: "MA",
    phoneCode: 261,
    langId: 1033,
    country: "Madagascar"
  },
  {
    fips: "MA",
    phoneCode: 261,
    langId: 1037,
    country: "מדגסקאר"
  },
  {
    fips: "MQ",
    phoneCode: 596,
    langId: 1033,
    country: "Martinique"
  },
  {
    fips: "MQ",
    phoneCode: 596,
    langId: 1037,
    country: "מארטיניק"
  },
  {
    fips: "MC",
    phoneCode: 853,
    langId: 1033,
    country: "Macau"
  },
  {
    fips: "MC",
    phoneCode: 853,
    langId: 1037,
    country: "מאקאו"
  },
  {
    fips: "MD",
    phoneCode: 373,
    langId: 1033,
    country: "Moldova, Republic of"
  },
  {
    fips: "MD",
    phoneCode: 373,
    langId: 1037,
    country: "מולדביה"
  },
  {
    fips: "MF",
    phoneCode: 269,
    langId: 1033,
    country: "Mayotte"
  },
  {
    fips: "MF",
    phoneCode: 269,
    langId: 1037,
    country: "מאיוטי"
  },
  {
    fips: "MG",
    phoneCode: 976,
    langId: 1033,
    country: "Mongolia"
  },
  {
    fips: "MG",
    phoneCode: 976,
    langId: 1037,
    country: "מונגוליה"
  },
  {
    fips: "MH",
    phoneCode: 473,
    langId: 1033,
    country: "Montserrat"
  },
  {
    fips: "MH",
    phoneCode: 473,
    langId: 1037,
    country: "מונטסרט"
  },
  {
    fips: "MW",
    phoneCode: 265,
    langId: 1033,
    country: "Malawi"
  },
  {
    fips: "MW",
    phoneCode: 265,
    langId: 1037,
    country: "מאלאוי"
  },
  {
    fips: "ME",
    phoneCode: 381,
    langId: 1033,
    country: "Montenegro"
  },
  {
    fips: "ME",
    phoneCode: 381,
    langId: 1037,
    country: "מונטנגרו"
  },
  {
    fips: "MK",
    phoneCode: 389,
    langId: 1033,
    country: "Macedonia"
  },
  {
    fips: "MK",
    phoneCode: 389,
    langId: 1037,
    country: "מקדוניה"
  },
  {
    fips: "ML",
    phoneCode: 223,
    langId: 1033,
    country: "Mali"
  },
  {
    fips: "ML",
    phoneCode: 223,
    langId: 1037,
    country: "מאלי"
  },
  {
    fips: "MN",
    phoneCode: 33,
    langId: 1033,
    country: "Monaco"
  },
  {
    fips: "MN",
    phoneCode: 33,
    langId: 1037,
    country: "מונקו"
  },
  {
    fips: "MO",
    phoneCode: 212,
    langId: 1033,
    country: "Morocco"
  },
  {
    fips: "MO",
    phoneCode: 212,
    langId: 1037,
    country: "מרוקו"
  },
  {
    fips: "MP",
    phoneCode: 230,
    langId: 1033,
    country: "Mauritius"
  },
  {
    fips: "MP",
    phoneCode: 230,
    langId: 1037,
    country: "מוריציוס"
  },
  {
    fips: "MR",
    phoneCode: 222,
    langId: 1033,
    country: "Mauritania"
  },
  {
    fips: "MR",
    phoneCode: 222,
    langId: 1037,
    country: "מאוריטניה"
  },
  {
    fips: "MT",
    phoneCode: 356,
    langId: 1033,
    country: "Malta"
  },
  {
    fips: "MT",
    phoneCode: 356,
    langId: 1037,
    country: "מלטה"
  },
  {
    fips: "MU",
    phoneCode: 968,
    langId: 1033,
    country: "Oman"
  },
  {
    fips: "MU",
    phoneCode: 968,
    langId: 1037,
    country: "עומן"
  },
  {
    fips: "MV",
    phoneCode: 960,
    langId: 1033,
    country: "Maldives"
  },
  {
    fips: "MV",
    phoneCode: 960,
    langId: 1037,
    country: "מולדביה"
  },
  {
    fips: "MX",
    phoneCode: 52,
    langId: 1033,
    country: "Mexico"
  },
  {
    fips: "MX",
    phoneCode: 52,
    langId: 1037,
    country: "מקסיקו"
  },
  {
    fips: "MY",
    phoneCode: 60,
    langId: 1033,
    country: "Malaysia"
  },
  {
    fips: "MY",
    phoneCode: 60,
    langId: 1037,
    country: "מלזיה"
  },
  {
    fips: "MZ",
    phoneCode: 258,
    langId: 1033,
    country: "Mozambique"
  },
  {
    fips: "MZ",
    phoneCode: 258,
    langId: 1037,
    country: "מוזאמביק"
  },
  {
    fips: "NC",
    phoneCode: 687,
    langId: 1033,
    country: "New Caledonia"
  },
  {
    fips: "NC",
    phoneCode: 687,
    langId: 1037,
    country: "קלנדוניה החדשה"
  },
  {
    fips: "NE",
    phoneCode: 683,
    langId: 1033,
    country: "Niue"
  },
  {
    fips: "NE",
    phoneCode: 683,
    langId: 1037,
    country: "ניאו"
  },
  {
    fips: "NG",
    phoneCode: 227,
    langId: 1033,
    country: "Niger"
  },
  {
    fips: "NG",
    phoneCode: 227,
    langId: 1037,
    country: "ניגר"
  },
  {
    fips: "VU",
    phoneCode: 678,
    langId: 1033,
    country: "Vanuatu"
  },
  {
    fips: "VU",
    phoneCode: 678,
    langId: 1037,
    country: "ואנואטו"
  },
  {
    fips: "NI",
    phoneCode: 234,
    langId: 1033,
    country: "Nigeria"
  },
  {
    fips: "NI",
    phoneCode: 234,
    langId: 1037,
    country: "ניגריה"
  },
  {
    fips: "NL",
    phoneCode: 31,
    langId: 1033,
    country: "Netherlands"
  },
  {
    fips: "NL",
    phoneCode: 31,
    langId: 1037,
    country: "הולנד"
  },
  {
    fips: "NO",
    phoneCode: 47,
    langId: 1033,
    country: "Norway"
  },
  {
    fips: "NO",
    phoneCode: 47,
    langId: 1037,
    country: "נורווגיה"
  },
  {
    fips: "NP",
    phoneCode: 977,
    langId: 1033,
    country: "Nepal"
  },
  {
    fips: "NP",
    phoneCode: 977,
    langId: 1037,
    country: "נפאל"
  },
  {
    fips: "NR",
    phoneCode: 674,
    langId: 1033,
    country: "Nauru"
  },
  {
    fips: "NR",
    phoneCode: 674,
    langId: 1037,
    country: "נאורו"
  },
  {
    fips: "SR",
    phoneCode: 597,
    langId: 1033,
    country: "Suriname"
  },
  {
    fips: "SR",
    phoneCode: 597,
    langId: 1037,
    country: "סורינאם"
  },
  {
    fips: "NL",
    phoneCode: 599,
    langId: 1033,
    country: "Netherlands Antilles"
  },
  {
    fips: "NL",
    phoneCode: 599,
    langId: 1037,
    country: "אנטיליים הולנדים"
  },
  {
    fips: "NU",
    phoneCode: 505,
    langId: 1033,
    country: "Nicaragua"
  },
  {
    fips: "NU",
    phoneCode: 505,
    langId: 1037,
    country: "ניקרגואה"
  },
  {
    fips: "NZ",
    phoneCode: 64,
    langId: 1033,
    country: "New Zealand"
  },
  {
    fips: "NZ",
    phoneCode: 64,
    langId: 1037,
    country: "ניו זילנד"
  },
  {
    fips: "PA",
    phoneCode: 595,
    langId: 1033,
    country: "Paraguay"
  },
  {
    fips: "PA",
    phoneCode: 595,
    langId: 1037,
    country: "פרגוואי"
  },
  {
    fips: "PE",
    phoneCode: 51,
    langId: 1033,
    country: "Peru"
  },
  {
    fips: "PE",
    phoneCode: 51,
    langId: 1037,
    country: "פרו"
  },
  {
    fips: "PK",
    phoneCode: 92,
    langId: 1033,
    country: "Pakistan"
  },
  {
    fips: "PK",
    phoneCode: 92,
    langId: 1037,
    country: "פקיסטן"
  },
  {
    fips: "PL",
    phoneCode: 48,
    langId: 1033,
    country: "Polska"
  },
  {
    fips: "PL",
    phoneCode: 48,
    langId: 1037,
    country: "פולין"
  },
  {
    fips: "PM",
    phoneCode: 507,
    langId: 1033,
    country: "Panama"
  },
  {
    fips: "PM",
    phoneCode: 507,
    langId: 1037,
    country: "פנמה"
  },
  {
    fips: "PT",
    phoneCode: 351,
    langId: 1033,
    country: "Portugal"
  },
  {
    fips: "PT",
    phoneCode: 351,
    langId: 1037,
    country: "פורטוגל"
  },
  {
    fips: "PG",
    phoneCode: 675,
    langId: 1033,
    country: "Papua New Guinea"
  },
  {
    fips: "PG",
    phoneCode: 675,
    langId: 1037,
    country: "פפואה ניו-גינאה"
  },
  {
    fips: "PS",
    phoneCode: 680,
    langId: 1033,
    country: "Palau"
  },
  {
    fips: "PS",
    phoneCode: 680,
    langId: 1037,
    country: "פאלאו"
  },
  {
    fips: "GW",
    phoneCode: 245,
    langId: 1033,
    country: "Guinea-Bissau"
  },
  {
    fips: "GW",
    phoneCode: 245,
    langId: 1037,
    country: "גינאה-ביסאו"
  },
  {
    fips: "QA",
    phoneCode: 974,
    langId: 1033,
    country: "Qatar"
  },
  {
    fips: "QA",
    phoneCode: 974,
    langId: 1037,
    country: "קטר"
  },
  {
    fips: "BO",
    phoneCode: 591,
    langId: 1033,
    country: "Bolivia"
  },
  {
    fips: "BO",
    phoneCode: 591,
    langId: 1037,
    country: "בוליביה"
  },
  {
    fips: "RE",
    phoneCode: 262,
    langId: 1033,
    country: "Reunion"
  },
  {
    fips: "RE",
    phoneCode: 262,
    langId: 1037,
    country: "רה-יוניון"
  },
  {
    fips: "MH",
    phoneCode: 692,
    langId: 1033,
    country: "Marshall Islands"
  },
  {
    fips: "MH",
    phoneCode: 692,
    langId: 1037,
    country: "איי מרשל"
  },
  {
    fips: "RO",
    phoneCode: 40,
    langId: 1033,
    country: "Romania"
  },
  {
    fips: "RO",
    phoneCode: 40,
    langId: 1037,
    country: "רומניה"
  },
  {
    fips: "PH",
    phoneCode: 63,
    langId: 1033,
    country: "Philippines"
  },
  {
    fips: "PH",
    phoneCode: 63,
    langId: 1037,
    country: "פיליפינים"
  },
  {
    fips: "PR",
    phoneCode: 787,
    langId: 1033,
    country: "Puerto Rico"
  },
  {
    fips: "PR",
    phoneCode: 787,
    langId: 1037,
    country: "פורטוריקו"
  },
  {
    fips: "RS",
    phoneCode: 7,
    langId: 1033,
    country: "Russia"
  },
  {
    fips: "RS",
    phoneCode: 7,
    langId: 1037,
    country: "רוסיה"
  },
  {
    fips: "RW",
    phoneCode: 250,
    langId: 1033,
    country: "Rwanda"
  },
  {
    fips: "RW",
    phoneCode: 250,
    langId: 1037,
    country: "רואנדה"
  },
  {
    fips: "SA",
    phoneCode: 966,
    langId: 1033,
    country: "Saudi Arabia"
  },
  {
    fips: "SA",
    phoneCode: 966,
    langId: 1037,
    country: "סעודיה"
  },
  {
    fips: "SE",
    phoneCode: 248,
    langId: 1033,
    country: "Seychelles"
  },
  {
    fips: "SE",
    phoneCode: 248,
    langId: 1037,
    country: "סיישל"
  },
  {
    fips: "ZA",
    phoneCode: 27,
    langId: 1033,
    country: "South Africa"
  },
  {
    fips: "ZA",
    phoneCode: 27,
    langId: 1037,
    country: "דרום אפריקה"
  },
  {
    fips: "SG",
    phoneCode: 221,
    langId: 1033,
    country: "Senegal"
  },
  {
    fips: "SG",
    phoneCode: 221,
    langId: 1037,
    country: "סנגל"
  },
  {
    fips: "SI",
    phoneCode: 386,
    langId: 1033,
    country: "Slovenia"
  },
  {
    fips: "SI",
    phoneCode: 386,
    langId: 1037,
    country: "סלובניה"
  },
  {
    fips: "SL",
    phoneCode: 232,
    langId: 1033,
    country: "Sierra Leone"
  },
  {
    fips: "SL",
    phoneCode: 232,
    langId: 1037,
    country: "סלובקיה"
  },
  {
    fips: "SM",
    phoneCode: 378,
    langId: 1033,
    country: "San Marino"
  },
  {
    fips: "SM",
    phoneCode: 378,
    langId: 1037,
    country: "סאן מרינו"
  },
  {
    fips: "SN",
    phoneCode: 65,
    langId: 1033,
    country: "Singapore"
  },
  {
    fips: "SN",
    phoneCode: 65,
    langId: 1037,
    country: "סינגפור"
  },
  {
    fips: "SO",
    phoneCode: 252,
    langId: 1033,
    country: "Somalia"
  },
  {
    fips: "SO",
    phoneCode: 252,
    langId: 1037,
    country: "סומליה"
  },
  {
    fips: "ES",
    phoneCode: 34,
    langId: 1033,
    country: "España"
  },
  {
    fips: "ES",
    phoneCode: 34,
    langId: 1037,
    country: "ספרד"
  },
  {
    fips: "SU",
    phoneCode: 249,
    langId: 1033,
    country: "Sudan"
  },
  {
    fips: "SU",
    phoneCode: 249,
    langId: 1037,
    country: "סודן"
  },
  {
    fips: "SE",
    phoneCode: 46,
    langId: 1033,
    country: "Sweden"
  },
  {
    fips: "SE",
    phoneCode: 46,
    langId: 1037,
    country: "שבדיה"
  },
  {
    fips: "SY",
    phoneCode: 963,
    langId: 1033,
    country: "Syrian Arab Republic"
  },
  {
    fips: "SY",
    phoneCode: 963,
    langId: 1037,
    country: "סוריה"
  },
  {
    fips: "SZ",
    phoneCode: 41,
    langId: 1033,
    country: "Schweiz"
  },
  {
    fips: "SZ",
    phoneCode: 41,
    langId: 1037,
    country: "שוויץ"
  },
  {
    fips: "TH",
    phoneCode: 66,
    langId: 1033,
    country: "Thailand"
  },
  {
    fips: "TH",
    phoneCode: 66,
    langId: 1037,
    country: "תאילנד"
  },
  {
    fips: "TJ",
    phoneCode: 7,
    langId: 1033,
    country: "Tajikistan"
  },
  {
    fips: "TJ",
    phoneCode: 7,
    langId: 1037,
    country: "טג'קיסטן"
  },
  {
    fips: "TL",
    phoneCode: 690,
    langId: 1033,
    country: "Tokelau"
  },
  {
    fips: "TL",
    phoneCode: 690,
    langId: 1037,
    country: "טוקלאו"
  },
  {
    fips: "TN",
    phoneCode: 676,
    langId: 1033,
    country: "Tonga"
  },
  {
    fips: "TN",
    phoneCode: 676,
    langId: 1037,
    country: "טונגה"
  },
  {
    fips: "TO",
    phoneCode: 228,
    langId: 1033,
    country: "Togo"
  },
  {
    fips: "TO",
    phoneCode: 228,
    langId: 1037,
    country: "טוגו"
  },
  {
    fips: "ST",
    phoneCode: 239,
    langId: 1033,
    country: "Sao Tome and Principe"
  },
  {
    fips: "ST",
    phoneCode: 239,
    langId: 1037,
    country: "סאו טומה"
  },
  {
    fips: "TN",
    phoneCode: 216,
    langId: 1033,
    country: "Tunisia"
  },
  {
    fips: "TN",
    phoneCode: 216,
    langId: 1037,
    country: "תוניס"
  },
  {
    fips: "TR",
    phoneCode: 90,
    langId: 1033,
    country: "Turkey"
  },
  {
    fips: "TR",
    phoneCode: 90,
    langId: 1037,
    country: "טורקיה"
  },
  {
    fips: "TV",
    phoneCode: 688,
    langId: 1033,
    country: "Tuvalu"
  },
  {
    fips: "TV",
    phoneCode: 688,
    langId: 1037,
    country: "טובאלו"
  },
  {
    fips: "TW",
    phoneCode: 886,
    langId: 1033,
    country: "Taiwan"
  },
  {
    fips: "TW",
    phoneCode: 886,
    langId: 1037,
    country: "טייוואן"
  },
  {
    fips: "TM",
    phoneCode: 993,
    langId: 1033,
    country: "Turkmenistan"
  },
  {
    fips: "TM",
    phoneCode: 993,
    langId: 1037,
    country: "טורקמניסטן"
  },
  {
    fips: "TZ",
    phoneCode: 255,
    langId: 1033,
    country: "Tanzania, United Republic of"
  },
  {
    fips: "TZ",
    phoneCode: 255,
    langId: 1037,
    country: "טנזניה"
  },
  {
    fips: "UG",
    phoneCode: 256,
    langId: 1033,
    country: "Uganda"
  },
  {
    fips: "UG",
    phoneCode: 256,
    langId: 1037,
    country: "אוגנדה"
  },
  {
    fips: "GB",
    phoneCode: 44,
    langId: 1033,
    country: "United Kingdom"
  },
  {
    fips: "GB",
    phoneCode: 44,
    langId: 1037,
    country: "אנגליה"
  },
  {
    fips: "UA",
    phoneCode: 380,
    langId: 1033,
    country: "Ukraine"
  },
  {
    fips: "UA",
    phoneCode: 380,
    langId: 1037,
    country: "אוקראינה"
  },
  {
    fips: "US",
    phoneCode: 1,
    langId: 1033,
    country: "United States"
  },
  {
    fips: "US",
    phoneCode: 1,
    langId: 1037,
    country: "ארצות הברית"
  },
  {
    fips: "BF",
    phoneCode: 226,
    langId: 1033,
    country: "Burkina Faso"
  },
  {
    fips: "BF",
    phoneCode: 226,
    langId: 1037,
    country: "בורקינה פאסו"
  },
  {
    fips: "UY",
    phoneCode: 598,
    langId: 1033,
    country: "Uruguay"
  },
  {
    fips: "UY",
    phoneCode: 598,
    langId: 1037,
    country: "אורגוואי"
  },
  {
    fips: "UZ",
    phoneCode: 7,
    langId: 1033,
    country: "Uzbekistan"
  },
  {
    fips: "UZ",
    phoneCode: 7,
    langId: 1037,
    country: "אוזבקיסטאן"
  },
  {
    fips: "VE",
    phoneCode: 58,
    langId: 1033,
    country: "Venezuela"
  },
  {
    fips: "VE",
    phoneCode: 58,
    langId: 1037,
    country: "וונצואלה"
  },
  {
    fips: "VI",
    phoneCode: 284,
    langId: 1033,
    country: "British Virgin Islands"
  },
  {
    fips: "VI",
    phoneCode: 284,
    langId: 1037,
    country: "איי הבתולה הבריטיים"
  },
  {
    fips: "VN",
    phoneCode: 84,
    langId: 1033,
    country: "Vietnam"
  },
  {
    fips: "VN",
    phoneCode: 84,
    langId: 1037,
    country: "ויטנאם"
  },
  {
    fips: "VI",
    phoneCode: 340,
    langId: 1033,
    country: "Virgin Islands (US)"
  },
  {
    fips: "VI",
    phoneCode: 340,
    langId: 1037,
    country: "איי הבתולה של ארה\"ב"
  },
  {
    fips: "VA",
    phoneCode: 39,
    langId: 1033,
    country: "Holy See (Vatican City)"
  },
  {
    fips: "VA",
    phoneCode: 39,
    langId: 1037,
    country: "הוותיקן"
  },
  {
    fips: "NA",
    phoneCode: 264,
    langId: 1033,
    country: "Namibia"
  },
  {
    fips: "NA",
    phoneCode: 264,
    langId: 1037,
    country: "נמיביה"
  },
  {
    fips: "WF",
    phoneCode: 681,
    langId: 1033,
    country: "Wallis and Futuna"
  },
  {
    fips: "WF",
    phoneCode: 681,
    langId: 1037,
    country: "ואליס ופוטונה"
  },
  {
    fips: "WS",
    phoneCode: 684,
    langId: 1033,
    country: "Samoa"
  },
  {
    fips: "WS",
    phoneCode: 684,
    langId: 1037,
    country: "סמוואה"
  },
  {
    fips: "CH",
    phoneCode: 268,
    langId: 1033,
    country: "Swaziland"
  },
  {
    fips: "CH",
    phoneCode: 268,
    langId: 1037,
    country: "סווזילנד"
  },
  {
    fips: "RS",
    phoneCode: 381,
    langId: 1033,
    country: "Serbia and Montenegro"
  },
  {
    fips: "RS",
    phoneCode: 381,
    langId: 1037,
    country: "סרביה"
  },
  {
    fips: "YE",
    phoneCode: 381,
    langId: 1033,
    country: "Yemen"
  },
  {
    fips: "YE",
    phoneCode: 381,
    langId: 1037,
    country: "ימן"
  },
  {
    fips: "ZA",
    phoneCode: 260,
    langId: 1033,
    country: "Zambia"
  },
  {
    fips: "ZA",
    phoneCode: 260,
    langId: 1037,
    country: "זמביה"
  },
  {
    fips: "ZW",
    phoneCode: 263,
    langId: 1033,
    country: "Zimbabwe"
  },
  {
    fips: "ZW",
    phoneCode: 263,
    langId: 1037,
    country: "זימבבואה"
  }
] as const